import { render, staticRenderFns } from "./SidebarLeft.vue?vue&type=template&id=34521666&scoped=true&"
import script from "./SidebarLeft.vue?vue&type=script&lang=js&"
export * from "./SidebarLeft.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLeft.vue?vue&type=style&index=0&id=34521666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34521666",
  null
  
)

export default component.exports